<template>

  <div>
    <v-container class="text-sm-center" width="50" fixed>
      
      <!-- <input fixed type="text" v-model="search" placeholder="search users"/> -->
      <v-text-field
            fixed type="text" v-model="search" placeholder="search users"
            single-line
            outlined
          ></v-text-field>
    </v-container>

    <h1 class="display-2 text-center my-3 mt-6">All Users</h1>
  <!-- old stuff -->
      <v-layout>
        <v-flex xs12 sm10 md8 offset-sm1 offset-md2>
          <v-card
            class="mx-auto"
            max-width="400"
            v-for="social in filteredUsers" :key="social.id"
            >
                <v-img                
                class="white--text align-end"
                height="200px"
                :src="social.profilePic"
                v-if="social.profilePic !== ''"
                >                
                <v-card-title>{{social.name}}</v-card-title>
                </v-img>

                <v-img
                class="white--text align-end"
                height="200px"
                src="https://wallpapercave.com/wp/IooPgL8.jpg"
                v-else
                >
                <v-card-title>{{social.name}}</v-card-title>
                </v-img>

                <v-card-text class="text--primary">
                <div class="font-weight-black">{{social.username.toUpperCase()}}</div>

                <div>{{social.bio}}</div>
                </v-card-text>

                <v-card-actions>
                <v-btn
                  text
                  color="deep-purple accent-4"
                  :to="'/messages/' + social.id"
                >
                  Message
                </v-btn>
                <v-btn
                  text
                  color="deep-purple accent-4"
                  :to="'/profile/' + social.id"
                >
                  Read Profile
                          </v-btn>
                <v-spacer></v-spacer>
                <v-btn v-if="!friends(social.id)" @click="sendRequest(social.id)">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-flex>
      </v-layout>
      <Usercard></Usercard>
    </div>
</template>

<script>
import Usercard from '@/components/Frontend/UserCard.vue'
import {mapGetters} from 'vuex'
export default {
  data (){
    return {
      message:'',
      search: '',
      allUsers: this.$store.getters.arrayUser
    }
  },
  computed: {
    //   socials() {
    //     return this.$store.state.allUsers
    //   }
    filteredUsers:function() {
      return this.allUsers.filter((user) => {
        return user.username.toLowerCase().match(this.search.toLowerCase()) || user.name.toLowerCase().match(this.search.toLowerCase())
      })
    }
  },
  methods: {
    onLoadFriend(friendid){
      this.$router.push('/profile/' + friendid)
    },
    newUser(social) {
        return this.$store.state.allUsers[social].name
    },
     newProfile(social) {
        return this.$store.state.allUsers[social].profilePic
    },
    sendRequest(social){
      this.$store.dispatch('firebaseAddFriend', social)
    },
    friends(social){
      return this.$store.state.friends[social]
    },
    sendMessage() {
      if(this.message !== '') {
        return this.$store.getters.search(this.message)
      }
    }
  },
  components: {
    Usercard,
  },
  mounted() {
    
    this.$store.dispatch('firebaseDeletePosts')
    this.$store.dispatch('firebaseGetGroupChat')
    this.$store.dispatch('firebaseGetNotifications')
  }

}
</script>
